import React from 'react';
import { Slider } from 'antd';
import { AGE_STEP_MONTHS, AGE_MAX_MONTHS, formatAge } from './age';

// Шкала качества: реальные значения score доходят до ~500.
const SCORE_MAX = 500;
const SCORE_STEP = 10;

const formatAgeRange = ([min, max]) => {
  const from = formatAge(min);
  const to = max >= AGE_MAX_MONTHS ? `${formatAge(AGE_MAX_MONTHS)}+` : formatAge(max);

  // Полный диапазон = фильтр не применяется, так и подписываем, чтобы не гадать по цифрам.
  if (!Number(min) && max >= AGE_MAX_MONTHS) return 'Any';

  return `${from} – ${to}`;
};

const RatingSidebar = ({ filters, onFilterChange }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    onFilterChange({ ...filters, [name]: value });
  };

  const ageRange = [
    Number(filters.minAgeMonths) || 0,
    Number(filters.maxAgeMonths) || AGE_MAX_MONTHS,
  ];

  const handleAgeChange = ([minAgeMonths, maxAgeMonths]) => {
    onFilterChange({ ...filters, minAgeMonths, maxAgeMonths });
  };

  const scoreRange = [
    Number(filters.minScore) || 0,
    Number(filters.maxScore) || SCORE_MAX,
  ];

  const handleScoreChange = ([minScore, maxScore]) => {
    onFilterChange({ ...filters, minScore, maxScore });
  };

  return (
    <div className="sidebar-filters">
      <h3>Filters</h3>

      <div className="filter-group">
        <label>Keyword</label>
        <input
          type="text"
          name="keyword"
          value={filters.keyword}
          onChange={handleChange}
          placeholder="Search requests..."
        />
      </div>

      <div className="filter-group">
        <label>Content Type</label>
        <select name="contentType" value={filters.contentType} onChange={handleChange}>
          <option value="All">All Types</option>
          <option value="Photos">Photos</option>
          <option value="Illustrations">Illustrations</option>
          <option value="Vectors">Vectors</option>
        </select>
      </div>

      <div className="filter-group">
        {/* Обе границы качества — одним компонентом, что и возраст, ради единого вида */}
        <label>Quality ({scoreRange[0]} – {scoreRange[1]})</label>
        <Slider
          range
          min={0}
          max={SCORE_MAX}
          step={SCORE_STEP}
          value={scoreRange}
          onChange={handleScoreChange}
        />
      </div>

      <div className="filter-group">
        {/* Средний возраст работ в выдаче: обе границы, чтобы ловить и свежие ниши,
            и наоборот — застоявшиеся, где верх занят старыми работами. */}
        <label>Average age ({formatAgeRange(ageRange)})</label>
        <Slider
          range
          min={0}
          max={AGE_MAX_MONTHS}
          step={AGE_STEP_MONTHS}
          value={ageRange}
          onChange={handleAgeChange}
          tooltip={{ formatter: formatAge }}
        />
      </div>
    </div>
  );
};

export default RatingSidebar;
